"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = void 0;
exports.dark = {
    "background": {
        "default": "#000000",
        "contrast": "#1a1a1a",
        "hover": "#0f0f0f",
        "selected": "#1a1a1a",
        "overlay": "#1a1a1a",
        "primary": "#160c34",
        "critical": "#2c120a",
        "warning": "#332107",
        "success": "#0e1f14",
        "highlighted": {
            "primary": "#8265dc",
            "success": "#459B64",
            "warning": "#E6A03B",
            "critical": "#D4613A"
        }
    },
    "border": {
        "default": "#333333",
        "contrast": "#484848",
        "selected": "#ffffff",
        "primary": "#351d7c",
        "success": "#2b5f3d",
        "warning": "#825412",
        "critical": "#76301b"
    },
    "content": {
        "default": "#ffffff",
        "subdued": "#999999",
        "disabled": "#4d4d4d",
        "placeholder": "#808080",
        "primary": "#8265dc",
        "success": "#459B64",
        "warning": "#E6A03B",
        "critical": "#D4613A",
        "accent": {
            "success": "#459B64",
            "warning": "#E6A03B",
            "critical": "#D4613A"
        },
        "above": {
            "primary": "#000000",
            "secondary": "#ffffff",
            "text": "#ffffff",
            "contrast": "#ffffff",
            "critical": "#D4613A"
        }
    },
    "interactive": {
        "primary": {
            "default": "#ffffff",
            "hover": "#f2f2f2",
            "pressed": "#dbdbdb"
        },
        "secondary": {
            "default": "rgba(255, 255, 255, 0.12)",
            "hover": "rgba(255, 255, 255, 0.16)",
            "pressed": "rgba(255, 255, 255, 0.18)"
        },
        "contrast": {
            "default": "#4b5367",
            "hover": "rgba(75, 83, 103, 0.9)",
            "pressed": "rgba(75, 83, 103, 0.75)"
        },
        "text": {
            "default": "rgba(255, 255, 255, 0)",
            "hover": "rgba(255, 255, 255, 0.1)",
            "pressed": "rgba(255, 255, 255, 0.12)"
        },
        "critical": {
            "default": "#2c120a",
            "hover": "#3f1a0e",
            "pressed": "#602716"
        },
        "disabled": "#232529"
    },
    "benefits": {
        "mealVoucher": {
            "content": {
                "default": "#FF5A1A",
                "selected": "#ff8c5f"
            },
            "background": {
                "default": "#381000",
                "selected": "#812400"
            }
        },
        "gift": {
            "content": {
                "default": "#EF1090",
                "selected": "#f458b1"
            },
            "background": {
                "default": "#30031d",
                "selected": "#6e0742"
            }
        },
        "mobility": {
            "content": {
                "default": "#79CC33",
                "selected": "#a1db70"
            },
            "background": {
                "default": "#18290a",
                "selected": "#385e17"
            }
        },
        "personalWallet": {
            "content": {
                "default": "#1A96DA",
                "selected": "#59b7eb"
            },
            "background": {
                "default": "#051e2c",
                "selected": "#0c4564"
            }
        },
        "cashback": {
            "content": {
                "default": "#FCB408",
                "selected": "#fdcb52"
            },
            "background": {
                "default": "#332401",
                "selected": "#765401"
            }
        }
    },
    "social": {
        "pot": {
            "content": {
                "default": "#1A96DA",
                "selected": "#59b7eb"
            },
            "background": {
                "default": "#051e2c",
                "selected": "#0c4564"
            }
        },
        "activity": {
            "content": {
                "default": "#79CC33",
                "selected": "#a1db70"
            },
            "background": {
                "default": "#18290a",
                "selected": "#385e17"
            }
        },
        "pulse": {
            "content": {
                "default": "#33C794",
                "selected": "#6edab5"
            },
            "background": {
                "default": "#0a281e",
                "selected": "#175c44"
            }
        },
        "praise": {
            "default": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#f458b1"
                },
                "background": {
                    "default": "#30031d",
                    "selected": "#6e0742"
                }
            },
            "birthday": {
                "content": {
                    "default": "#8265dc",
                    "selected": "#a893e7"
                },
                "background": {
                    "default": "#160c34",
                    "selected": "#321b78"
                }
            },
            "celebration": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#f458b1"
                },
                "background": {
                    "default": "#30031d",
                    "selected": "#6e0742"
                }
            },
            "congrats": {
                "content": {
                    "default": "#79CC33",
                    "selected": "#a1db70"
                },
                "background": {
                    "default": "#18290a",
                    "selected": "#385e17"
                }
            },
            "egoboost": {
                "content": {
                    "default": "#1A96DA",
                    "selected": "#59b7eb"
                },
                "background": {
                    "default": "#051e2c",
                    "selected": "#0c4564"
                }
            },
            "onboarding": {
                "content": {
                    "default": "#FCB408",
                    "selected": "#fdcb52"
                },
                "background": {
                    "default": "#332401",
                    "selected": "#765401"
                }
            },
            "proanniversary": {
                "content": {
                    "default": "#FF5A1A",
                    "selected": "#ff8c5f"
                },
                "background": {
                    "default": "#381000",
                    "selected": "#812400"
                }
            },
            "procelebration": {
                "content": {
                    "default": "#FF5A1A",
                    "selected": "#ff8c5f"
                },
                "background": {
                    "default": "#381000",
                    "selected": "#812400"
                }
            },
            "thanks": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#f458b1"
                },
                "background": {
                    "default": "#30031d",
                    "selected": "#6e0742"
                }
            }
        },
        "article": {
            "content": {
                "default": "#FCB408",
                "selected": "#fdcb52"
            },
            "background": {
                "default": "#332401",
                "selected": "#765401"
            }
        }
    },
    "cards": {
        "black": {
            "primary": "#111111",
            "accent": "#272727"
        },
        "grey": {
            "primary": "#585858",
            "accent": "#e5e5e5"
        },
        "midnightBlue": {
            "primary": "#00084b",
            "accent": "#e5e8ff"
        },
        "gold": {
            "primary": "#c8ba95",
            "accent": "#f3f0e7"
        },
        "pink": {
            "primary": "#edc2bd",
            "accent": "#f7e5e3"
        }
    },
    "travel": {
        "carGradient": "linear-gradient(139deg, #fff8d1 0%, #f6ec99 16.15%, #ffaf79 47.19%, #991333 99.48%)",
        "trainGradient": "linear-gradient(-41deg, #008c6b 0%, #4cf0c9 48.84%, #dff6af 82.94%, #effad7 100%)",
        "flightGradient": "linear-gradient(139deg, #ccfbf0 0%, #99f7e0 21.94%, #7099ff 57.17%, #1f4199 100%)",
        "hotelGradient": "linear-gradient(135deg, #ffd2dd 0%, #ffa6bb 18.38%, #c060f5 51.55%, #631191 100%)"
    }
};
